/**
 * Mapping from phone country code to ISO 3166-1 country code
 */
export const PHONE_TO_ISO: Record<number, string> = {
  57: 'CO',     // Colombia
  502: 'GT',    // Guatemala
  503: 'SV',    // El Salvador
  504: 'HN',    // Honduras
  507: 'PA',    // Panamá
  1809: 'DO',   // República Dominicana (1 + área 809)
  52: 'MX',     // México
  501: 'BZ',    // Belice
  505: 'NI',    // Nicaragua
  506: 'CR',    // Costa Rica
  51: 'PE',     // Perú
  53: 'CU',     // Cuba
  54: 'AR',     // Argentina
  55: 'BR',     // Brasil
  56: 'CL',     // Chile
  58: 'VE',     // Venezuela
  591: 'BO',    // Bolivia
  592: 'GY',    // Guyana
  593: 'EC',    // Ecuador
  594: 'GF',    // Guyana Francesa
  595: 'PY',    // Paraguay
  597: 'SR',    // Surinam
  598: 'UY',    // Uruguay
  509: 'HT',    // Haití
};

/**
 * Helper function to get the ISO country code for a country
 * @param countryId - The country ID (phone code or phone+area code)
 */
export function getCountryCode(countryId: number): string {
  return PHONE_TO_ISO[countryId] || '';
}